import React, { useState } from "react";
import { IonPopover, IonItem } from "@ionic/react";

import styled from "styled-components";
const Container = styled.div``;

const ChildrenContainer = styled.div``;

const Popover = styled(IonPopover)``;
const PopoverMenuContainer = styled.div``;
const PopoverMenuOption = styled(IonItem)``;

const ActionPopover = (props) => {
  const [popoverState, setPopoverState] = useState({
    showPopover: false,
    event: undefined,
  });

  const menuOptions = props.menuOptions ?? [];

  return (
    <Container {...props}>
      <ChildrenContainer
        onClick={(e) => {
          e.persist();
          setPopoverState({
            showPopover: true,
            event: e,
          });
        }}
      >
        {props.children}
      </ChildrenContainer>
      <Popover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => {
          setPopoverState({
            showPopover: false,
            event: undefined,
          });
        }}
        showBackdrop={false}
        animated={false}
      >
        <PopoverMenuContainer>
          {menuOptions.map((m, index) => {
            return (
              <PopoverMenuOption
                key={index}
                button={true}
                onClick={() => {
                  setPopoverState({
                    showPopover: false,
                    event: undefined,
                  });

                  m.onClick(props.actionData);
                }}
              >
                {m.label}
              </PopoverMenuOption>
            );
          })}
        </PopoverMenuContainer>
      </Popover>
    </Container>
  );
};

export default ActionPopover;
